export const isTrackedOrderPath = (orderID: string | undefined, pathname: string) =>
  !!orderID && pathname.startsWith(`/order/${orderID}/paired-cost/`);

const comparablesRoutes = new Set(['paired-cost/features', 'paired-cost/rental-features']);
const trackedSearchParams = ['addComps', 'filters'] as const;

const getPathAndSearch = (pathname: string, search: string) => {
  if (search) return { pathname, search };

  const queryStart = pathname.indexOf('?');
  if (queryStart === -1) return { pathname, search: '' };

  return {
    pathname: pathname.slice(0, queryStart),
    search: pathname.slice(queryStart),
  };
};

const getTrackedSearch = (pageKey: string, search: string) => {
  if (!comparablesRoutes.has(pageKey)) return '';
  const params = new URLSearchParams(search);
  const trackedParams = trackedSearchParams.filter((param) => params.get(param) === 'true');
  return trackedParams.length > 0
    ? `?${trackedParams.map((param) => `${param}=true`).join('&')}`
    : '';
};

export const getPageKey = (orderID: string | undefined, pathname: string, search = '') => {
  if (!orderID) return pathname;
  const pathAndSearch = getPathAndSearch(pathname, search);
  const pageKey = pathAndSearch.pathname.replace(new RegExp(`^.*/order/${orderID}/`), '');
  return `${pageKey}${getTrackedSearch(pageKey, pathAndSearch.search)}`;
};

export const getRouteHistoryEntry = (orderID: string | undefined, pathname: string, search = '') =>
  getPageKey(orderID, pathname, search);
